module.exports = __webpack_public_path__ + "static/img/6.4b16d97d.png";